





import {Component, Vue} from "vue-property-decorator";
import {getFlowCount, getGuideDetail, login, signUp} from "@/services/api"
import { toastFailMessage } from "@/i18n/failMessage";
import store from "@/store";
import JSEncrypt from 'jsencrypt'
import {DisplayInfo} from "@/model/UserInfo";
import {defaultTimezone} from "@/services/config";

@Component({
})
export default class Login extends Vue {
  // 登录表单
  public formData = {
    email: '',
    password: ''
  }
  public signUpData = {
    email: '',
    password: '',
    phone: ''
  }
  public dialogVisible = false;
  public isCheckedTerms = true;
  public isCheckRegistered = true;
  public SuccessVisible = false;
  public signUpTips = '';
  public locationHref: string = location.origin;
  $message: any;
  $route: any;
  $router: any;

  created(): void {
    window.location.href = '/cartsee-new/login'
  }

  /**
   * 登录接口调用
   */
  async login(): Promise<void> {
    // 创建加密对象实例
    const encrypt = new JSEncrypt();
    const pubKey = `MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCt+CcQrM1/WAotGUivgWJx5HKRJwKxweHzqvB4bBlNpURXoO3iDPS/RVgw44uAy8IXdWJNQyzHYOTZy4Mlc/Izox1jhFe3mI5whry89kuIRytShg2cvTuR0spuRFbljO4QoOOJELt9tirBb2mvmzyzNMlT3+isUqvC4ThXe5mD4QIDAQAB`;
    encrypt.setPublicKey(pubKey) //设置公钥
    const password = encrypt.encrypt(this.formData.password)|| '';  // 对内容进行加密

    this.formData.email = this.formData.email.replace(/(^\s*)|(\s*$)/g,"");
    if(!this.formData.email) {
      this.$message.error(this.$tx('login.pleaseEnterYourUsername', '请输入用户名'));
      return;
    }
    if(!this.formData.password) {
      this.$message.error(this.$tx('login.passwordPh', '请输入密码'));
      return;
    }
    if(!this.isCheckedTerms) {
      let isCheck = false
      await this.$msgbox({
        title: this.$tx('settings.page.notice', '提示'),
        message: `<p>{{ $tx('login.agreePrefix', '我已阅读并同意') }}<a target="_blank" style="color: #513EFF" href=${this.locationHref+'/userAgreement.html'}>{{ $tx('login.userAgreement', '《用户协议》') }}</a>{{ $tx('login.and', '和') }}<a target="_blank" style="color: #513EFF" href=${this.locationHref+'/PrivacyPolicy.html'}>{{ $tx('login.privacy', '《隐私政策》') }}</a></p>`,
        dangerouslyUseHTMLString: true,
        showCancelButton: true,
        confirmButtonText: this.$tx('login.agree', '同意'),
        cancelButtonText: this.$tx('common.cancel', '取消'),
      }).then(()=>{
        this.isCheckedTerms = true
        isCheck = true
      }).catch(() => {
        isCheck = false
      });
      if(!isCheck) {
        return;
      }
    }
    const res1 = await login({ email: this.formData.email, password}, true);
    if (res1.data && res1.data.code === 0) {
      // todo 和displayInfo一样在vuex里设置
      localStorage.setItem('token', res1.data.data.token);
      const displayInfo: DisplayInfo = {name: res1.data.data.name, email: this.formData.email};
      sessionStorage.setItem('sessionDisplayInfo', JSON.stringify(displayInfo));
      localStorage.removeItem('browserGuideShow');
      store.commit('SET_DISPLAY_INFO', displayInfo);
    } else {
      this.$message.error(toastFailMessage(res1.data));
      return
    }

    let defaultPath = '/guide';
    const res2 = await getGuideDetail({},true);
    // todo 和displayInfo一样在vuex里设置
    localStorage.setItem('timezone', res2.data.data.companyInfo.timezone|| defaultTimezone);
    const companyInfo = res2.data.data.companyInfo;
    store.commit('SET_COMPANY_INFO', companyInfo);
    if (res2.data.data.nextStep === -1) {
      defaultPath = '/home';
      const res3 = await getFlowCount({}, true);
      if(res3.data.data === 0) {
        defaultPath = '/account/settings';
        store.commit('SET_FLOW_COUNT', res3.data.data);
      }
    } else {
      store.commit('SET_TEMPLATE_INFO', res2.data.data);
    }

    const redirect: any = defaultPath === '/guide'? defaultPath : (this.$route.query.redirect || defaultPath);
    this.$router.replace(redirect);
  }

  /**
   * 注册
   */
  async signUp() {
    if(!this.signUpValidator()) {
      return;
    }
    if(!this.isCheckRegistered) {
      let isCheck = false
      await this.$msgbox({
        title: this.$tx('settings.page.notice', '提示'),
        message: `<p>{{ $tx('login.agreePrefix', '我已阅读并同意') }}<a target="_blank" style="color: #513EFF" href=${this.locationHref+'/userAgreement.html'}>{{ $tx('login.userAgreement', '《用户协议》') }}</a>{{ $tx('login.and', '和') }}<a target="_blank" style="color: #513EFF" href=${this.locationHref+'/PrivacyPolicy.html'}>{{ $tx('login.privacy', '《隐私政策》') }}</a></p>`,
        dangerouslyUseHTMLString: true,
        showCancelButton: true,
        confirmButtonText: this.$tx('login.agree', '同意'),
        cancelButtonText: this.$tx('common.cancel', '取消'),
      }).then(()=>{
        this.isCheckRegistered = true
        isCheck = true
      }).catch(() => {
        isCheck = false
      });
      if(!isCheck) {
        return;
      }
    }
    signUp({
      ...this.signUpData,
      ...(this.$route.query.integrationId === '31' && {
        integrationId: this.$route.query.integrationId,
        authorize_token_url: this.$route.query.authorize_token_url,
        code: this.$route.query.code
      })
    }, true).then(res => {
      this.signUpData = {
        email: '',
        password: '',
        phone: ''
      }
      this.SuccessVisible = true;
    }).catch(() => {
    })
  }

  signUpValidator() {
    if(!this.signUpData.email) {
      this.signUpTips = this.$tx('comp.pleaseEnterYourEmailAddress', '请输入邮箱');
      return false;
    }
    if(!(new RegExp("[\\w!#$%&'*+/=?^_`{|}~-]+(?:\\.[\\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\\w](?:[\\w-]*[\\w])?\\.)+[\\w](?:[\\w-]*[\\w])?")).test(this.signUpData.email)) {
      this.signUpTips = this.$tx('comp.pleaseEnterValidEmailAddress', '请输入正确的邮箱地址');
      return false;
    }
    if(!this.signUpData.phone) {
      this.signUpTips = this.$tx('login.pleaseEnterYourPhoneNumber', '请输入电话');
      return false;
    }
    if(!this.signUpData.password) {
      this.signUpTips = this.$tx('login.passwordPh', '请输入密码');
      return false;
    }
    if(this.signUpData.password.length < 8) {
      this.signUpTips = this.$tx('login.passwordMustBeAtLeast', '密码至少为8位');
      return false;
    }
    this.signUpTips = '';
    return true;
  }
}

